/** Returns true if the provided url is an absolute http, https or protocol-relative URL  */
export function isUrlAbsolute(url: string): boolean {
  return (
    url.startsWith('https://') ||
    url.startsWith('http://') ||
    url.startsWith('//')
  );
}
